import slice from "./datasetFilesSlice";

export default slice.reducer;
